// logic for direct authentication attempt over same connection to not probe first and consume auth_key
// the old probe-per-version logic that this replaced is kept for reference in old-probing-logic.md

export const NOVNC_VERSIONS = ["1.3.0", "1.6.0"] as const;
export type NoVncVersion = (typeof NOVNC_VERSIONS)[number];

export interface VncSettings {
  version: NoVncVersion;
  swapRB: boolean;
}

export const loadWorkingNoVnc = async (version: NoVncVersion = "1.3.0") => {
  // dynamically imported so only the requested copy ends up in the bundle
  const { default: RFBClass } = await import(
    version === "1.6.0"
      ? "@src/vendor/noVNC-1.6.0/core/rfb"
      : "@src/vendor/noVNC-1.3.0/core/rfb"
  );
  console.log(`Using noVNC ${version}`);
  return { RFBClass, version };
};
